
import type { WordExplorerDataResponse } from 'pages/WordExplorer/types';
import type { HTTPFunctions } from '../types';
import type { BrainPain } from 'pages/PublicBrainPain/types';
import type { SentimentAnalysis } from 'pages/PublicSentimentAnalysis/types';

const publics = ({ get, post }: HTTPFunctions) => ({
  publicWordExplorer: (word: string) =>
    get<WordExplorerDataResponse>(`/words/public/word-explorer/${word}?request_types=definitions&request_types=inflections&request_types=synonyms&request_types=cefr&request_types=level&request_types=synonyms_lexical`),
  publicReadabilityChecker: (text: string) => post<number>(`/readability/public/`, { text }),
  publicBrainPain: (text: string) => post<BrainPain>(`/brain-pain/public/`, { text }),
  publicSentimentAnalysis: (text: string) => post<SentimentAnalysis>(`/sentiment/public/`, { text })
});

export default publics;
